import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const initialRole = sp.get("role") === "doctor" ? "doctor" : "patient";
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "", role: initialRole });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await register(form);
      toast.success("Welcome to MediConnect!");
      if (u.role === "doctor") nav("/doctor/dashboard");
      else nav("/patient/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="card p-8">
        <h1 className="text-2xl font-extrabold text-slate-900">Create your account</h1>
        <p className="mt-1 text-sm text-slate-600">Join as a patient to book, or as a doctor to list your practice.</p>

        <div className="mt-6 grid grid-cols-2 gap-2 rounded-xl bg-slate-100 p-1">
          {["patient", "doctor"].map((r) => (
            <button
              key={r}
              data-testid={`register-role-${r}`}
              onClick={() => setForm({ ...form, role: r })}
              className={`rounded-lg px-4 py-2 text-sm font-semibold capitalize transition-all ${
                form.role === r ? "bg-white text-blue-700 shadow-sm" : "text-slate-600"
              }`}
            >
              I'm a {r}
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="reg-name" required className="input-field" placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input data-testid="reg-email" required type="email" className="input-field" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="reg-phone" className="input-field" placeholder="+91 phone number" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <input data-testid="reg-password" required type="password" minLength={6} className="input-field" placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button data-testid="register-submit" disabled={submitting} className="btn-primary w-full">
            {submitting ? "Creating account…" : "Create Account"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-slate-600">
          Already have an account?{" "}
          <Link to="/login" className="font-semibold text-blue-700 hover:text-blue-800">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
